// ======== Auth ========

export const DYNAMIC_KEY_STORAGE_TOKENS = [
  "dynamic_min_authentication_token",
  "dynamic_authentication_token",
];

export const NECTAR_URL = "https://nectar.ai";
export const TRYNECTAR_URL = "https://trynectar.ai";

// ======== DOMAINS ========

export const DOMAINS = {
  NECTAR_COMPANIONS: "nectarcompanions.online",
  NECTAR_LOVE: "nectarlove.online",
  NECTAR_DESIRE: "nectardesire.online",
  NECTAR_ROLEPLAY: "nectarroleplay.online",
};

// localhost domain
export const FALLBACK_DOMAIN = DOMAINS.NECTAR_COMPANIONS;

export const ELIZA_FORM_STEPS = {
  STYLE: "style",
  ETHNICITY: "ethnicity",
  BODY: "body",
  EYES: "eyes",
  HAIR_STYLE: "hair_style",
  HAIR_LENGTH: "hair_length",
  HAIR_COLOR: "hair_color",
  SOUL: "soul",
  SUMMARY: "summary",
  CREATE: "create",
  AUTH: "auth",
};

// Steps shown in the progress bar (combined hair steps)
export const ELIZA_PROGRESS_STEPS = {
  ETHNICITY: "ethnicity",
  BODY: "body",
  EYES: "eyes",
  HAIR: "hair", // Combined step for hair_style, hair_length, hair_color
  SOUL: "soul",
  SUMMARY: "summary",
};

// Maps internal form steps to their display step in progress bar
export const PROGRESS_STEP_MAPPING = {
  [ELIZA_FORM_STEPS.ETHNICITY]: ELIZA_PROGRESS_STEPS.ETHNICITY,
  [ELIZA_FORM_STEPS.BODY]: ELIZA_PROGRESS_STEPS.BODY,
  [ELIZA_FORM_STEPS.EYES]: ELIZA_PROGRESS_STEPS.EYES,
  [ELIZA_FORM_STEPS.HAIR_STYLE]: ELIZA_PROGRESS_STEPS.HAIR,
  [ELIZA_FORM_STEPS.HAIR_LENGTH]: ELIZA_PROGRESS_STEPS.HAIR,
  [ELIZA_FORM_STEPS.HAIR_COLOR]: ELIZA_PROGRESS_STEPS.HAIR,
  [ELIZA_FORM_STEPS.SOUL]: ELIZA_PROGRESS_STEPS.SOUL,
  [ELIZA_FORM_STEPS.SUMMARY]: ELIZA_PROGRESS_STEPS.SUMMARY,
};

export const LP_FAKE_FORM_STEPS = {
  STYLE: "style",
  INTRO: "intro", // define style
  ETHNICITY: "ethnicity", // only realism
  RACE: "race", // only anime
  TONE: "tone", // only anime
  BODY: "body",
  EYES: "eyes",
  HAIR_STYLE: "hair_style",
  HAIR_LENGTH: "hair_length",
  HAIR_COLOR: "hair_color",
  SOUL: "soul",
  SUMMARY: "summary",
  CREATE: "create",
  AUTH: "auth",
};

export const LANDING_FORM_STEPS = {
  INTRO: "intro", // define style
  ETHNICITY: "ethnicity", // only realism
  RACE: "race", // only anime
  TONE: "tone", // only anime
  BODY: "body",
  EYES: "eyes",
  HAIR: "hair",
  SOUL: "soul",
  SUMMARY: "summary",
  CREATE: "create",
  AUTH: "auth",
};

export const IGNORE_PROGRESS_STEPS = ["style", "intro", "create", "auth"];

export const STEP_LABELS = {
  [LP_FAKE_FORM_STEPS.INTRO]: "Style",
  [LP_FAKE_FORM_STEPS.ETHNICITY]: "Ethnicity",
  [LP_FAKE_FORM_STEPS.RACE]: "Race",
  [LP_FAKE_FORM_STEPS.TONE]: "Tone",
  [LP_FAKE_FORM_STEPS.BODY]: "Body",
  [LP_FAKE_FORM_STEPS.EYES]: "Eyes",
  [LP_FAKE_FORM_STEPS.HAIR_STYLE]: "Hair",
  [LP_FAKE_FORM_STEPS.HAIR_LENGTH]: "Hair",
  [LP_FAKE_FORM_STEPS.HAIR_COLOR]: "Hair",
  [LP_FAKE_FORM_STEPS.SOUL]: "Soul",
  [LP_FAKE_FORM_STEPS.SUMMARY]: "Summary",
};

// Labels for display steps (progress bar)
export const ELIZA_STEP_LABELS = {
  [ELIZA_PROGRESS_STEPS.ETHNICITY]: "Ethnicity",
  [ELIZA_PROGRESS_STEPS.BODY]: "Body",
  [ELIZA_PROGRESS_STEPS.EYES]: "Eyes",
  [ELIZA_PROGRESS_STEPS.HAIR]: "Hair",
  [ELIZA_PROGRESS_STEPS.SOUL]: "Soul",
  [ELIZA_PROGRESS_STEPS.SUMMARY]: "Summary",
};

// ========  COMPANIONS ========\

export const STYLES = {
  REALISM: "realism",
  ANIME: "anime",
};

export const GIRL_AGES = [
  {
    id: "teen",
    label: "Teen (18-23)",
  },
  {
    id: "young",
    label: "Young (24-29)",
  },
  {
    id: "milf",
    label: "Milf (30+)",
  },
];

export const GIRL_STYLES = [
  {
    id: STYLES.REALISM,
    label: "Realism",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/d2d17f5b-bfd8-40d3-ec5e-d730e968e400/public",
  },
  {
    id: STYLES.ANIME,
    label: "Anime",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c467ab52-3acd-4d9f-2afa-c0c362eb5c00/public",
  },
];

// ======== REALISM COMPANIONS ========\

export const GIRL_REALISM_ETHNICITY_GIFS = [
  {
    id: "asian",
    label: "Asian",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/59fbc4f0-6fe0-4cbb-24c4-b23786508400/public",
  },
  {
    id: "latina",
    label: "Latina",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/f8a144da-3d81-4313-aed3-d6c930637c00/public",
  },
  {
    id: "ebony",
    label: "Ebony",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/8b54144a-39ce-4513-7166-8fa6dca3b600/public",
  },
  {
    id: "white",
    label: "white",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/648a8cf7-81f3-4c17-8d53-ae3b09079100/public",
  },
];

export const GIRL_REALISM_HAIR_LENGTH = [
  {
    id: "pixie",
    label: "Pixie",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/1a939256-c65a-407e-3147-c322d71a1b00/public",
  },
  {
    id: "short",
    label: "Short",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/9af8252a-2440-4b53-ff65-dfcedb3a0d00/public",
  },
  {
    id: "medium",
    label: "Medium",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/d8cf02f6-db37-4599-d2d7-6742e4e1ec00/public",
  },
  {
    id: "long",
    label: "Long",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6f6136a4-dc53-4d31-33d4-74f62ff6e700/public",
  },
];

export const GIRL_REALISM_HAIR_COLORS = [
  {
    id: "black",
    label: "Black",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/3c76d429-ac11-4c2e-4c0d-b15948c3fa00/public",
  },
  {
    id: "brown",
    label: "Brown",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/0d35ef18-979d-4068-0c18-0f614b160700/public",
  },
  {
    id: "blonde",
    label: "Blonde",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/0a439404-df45-4a54-11ea-f40f5f40d600/public",
  },
  {
    id: "red",
    label: "Red",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/a1484be9-8578-4579-5c58-3594398ca800/public",
  },
  {
    id: "silver",
    label: "Silver",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c0ea35c9-4676-473c-6d92-c1b91e17fb00/public",
  },
  {
    id: "blue",
    label: "Blue",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/38c8ab26-b3e2-4d92-68df-d14ce5258200/public",
  },
];

export const GIRL_REALISM_EYE_COLOR = [
  {
    id: "blue",
    label: "Blue",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/41c29426-feb2-4c14-bc93-72aa4a542d00/public",
  },
  {
    id: "brown",
    label: "Brown",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/8f1db96d-0e91-4917-e9fa-73dafce0bd00/public",
  },
  {
    id: "green",
    label: "Green",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/dfa99b0a-9cf1-444b-87e1-b450da123900/public",
  },
  {
    id: "hazel",
    label: "Hazel",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6652da7b-a83c-4247-81a1-4a959107da00/public",
  },
];

export const GIRL_REALISM_ETHNICITY = [
  {
    id: "white",
    label: "White",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/4678b7e1-b93d-4861-e221-d79f16252d00/public",
  },
  {
    id: "hispanic",
    label: "Hispanic",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/515765e1-13b7-4e67-6047-fdcb42875900/public",
  },
  {
    id: "korean",
    label: "Korean",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/5ee6381b-fd85-4fbd-bf83-1ada5af83900/public",
  },
  {
    id: "middle eastern",
    label: "Middle Eastern",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6540b226-ba38-42aa-f704-d222965e1600/public",
  },
  {
    id: "indian",
    label: "Indian",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/44d75aa6-3cfe-42e3-4a71-32dba89b9e00/public",
  },
  {
    id: "chinese",
    label: "Chinese",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6142632d-c292-4c7c-945e-46e1adbf8300/public",
  },
  {
    id: "japanese",
    label: "Japanese",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/626be2d3-8d30-4abe-f3fc-a05d4deacc00/public",
  },
  {
    id: "vietnamese",
    label: "Vietnamese",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6a967f6e-89b5-4a26-9ca0-3bf7c2b65a00/public",
  },
];

export const GIRL_REALISM_HAIRSTYLES = [
  {
    id: "straight",
    label: "Straight",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c5255b6f-7169-49f0-fe1f-a28630fce500/public",
  },
  {
    id: "wavy",
    label: "Wavy",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/83f0387a-cda0-41d4-b3ca-cb7d1428fb00/public",
  },
  {
    id: "curly",
    label: "Curly",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/1cb82947-e27f-4516-fbac-b7974f3d1e00/public",
  },
  {
    id: "bangs",
    label: "Bangs",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/7ecf39fe-9e52-482a-c5f7-524d5db9a400/public",
  },
  {
    id: "hairbun",
    label: "Bun",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/55d08999-4823-4d65-af9b-52d7b4ff8b00/public",
  },
  {
    id: "ponytail",
    label: "Ponytail",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c904ad7b-256e-437f-2868-7a477f78a800/public",
  },
];

export const GIRL_REALISM_BODY_TYPE = [
  {
    id: "petite",
    label: "Petite",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/5809cc08-32e6-4340-0f61-ce804aa32700/public",
  },
  {
    id: "slim",
    label: "Slim",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/f1c3be19-47a0-418f-7c36-23429a5a1e00/public",
  },
  {
    id: "athletic body",
    label: "Athletic",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/10b0baa9-86c5-47a8-f9d3-7500f50de100/public",
  },
  {
    id: "hourglass_figure",
    label: "Hourglass",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/24f03b3c-b69e-49e3-ebc8-a138411c3000/public",
  },
  {
    id: "curvy",
    label: "Curvy",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/af5b62c0-a6f8-4eda-9070-838c14c43500/public",
  },
  {
    id: "bbw, thick",
    label: "BBW",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/a7dff444-f632-4aca-0b6a-9f32fcd3cf00/public",
  },
];

export const GIRL_REALISM_SUGGESTED_NAMES = [
  "Emma",
  "Olivia",
  "Ava",
  "Isabella",
  "Sophia",
];

// ======== ANIME COMPANIONS ========

export const GIRL_ANIME_RACE = [
  {
    id: "waifu",
    label: "Human",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/ccbd7c2a-d850-41a4-b9c3-e25e73469200/public",
  },
  {
    id: "elf",
    label: "Elf",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/379b98da-476d-4d4f-91cf-c7a5bf661800/public",
  },
  {
    id: "devil",
    label: "Devil",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/9f291d8f-919a-4031-578b-2ba9bba0a200/public",
  },
  {
    id: "angel",
    label: "Angel",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/446bb675-01db-4c03-9889-c8f5d766fa00/public",
  },
  {
    id: "witch",
    label: "Witch",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/ab7d00f3-93e2-46ba-7414-9edd2bb51300/public",
  },
  {
    id: "cyborg",
    label: "Cyborg",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/afce3712-3bf6-4f4f-af88-58591b3a2400/public",
  },
];

export const GIRL_ANIME_SKIN_TONE = [
  {
    id: "pale",
    label: "Pale",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/7c49c1ec-565e-4ac9-24b3-d7fa44938800/public",
  },
  {
    id: "fair",
    label: "Normal",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/06aff07e-7816-456a-c440-927e0351e100/public",
  },
  {
    id: "tan",
    label: "Tan",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/ad4e1fa8-51be-4138-33f1-3591def00700/public",
  },
];

export const GIRL_ANIME_EYE_COLOR = [
  {
    id: "black",
    label: "Black",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c2d2d953-ab19-4370-efda-d8a1be55f100/public",
  },
  {
    id: "brown",
    label: "Brown",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/7b8733c8-4831-4f7c-6a20-425a721a9e00/public",
  },
  {
    id: "yellow",
    label: "Yellow",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/5fcc79ef-b9e6-4e89-16d1-ad07d0af0500/public",
  },
  {
    id: "blue",
    label: "Blue",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6e058126-db89-40ed-9bb4-0c560f741900/public",
  },
  {
    id: "purple",
    label: "Purple",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/f36df02e-2e30-44a9-cfe0-6821c9b70e00/public",
  },
  {
    id: "red",
    label: "Red",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/de951c6c-bb7a-47dd-4f6a-33275c27b400/public",
  },
];

export const GIRL_ANIME_HAIR_COLORS = [
  {
    id: "black",
    label: "Black",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/1a955360-6155-4395-0c87-c3a74d970100/public",
  },
  {
    id: "brown",
    label: "Brown",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/ded5eceb-3ca0-4400-dfde-413ada3dc600/public",
  },
  {
    id: "blonde",
    label: "Blonde",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/71917c7c-008b-4611-bb59-e43f71691a00/public",
  },
  {
    id: "pink",
    label: "Pink",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/6842e5dd-c7f2-44d9-29b4-04cb9644bb00/public",
  },
  {
    id: "purple",
    label: "Purple",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c346b91b-25be-454f-5305-4cf04cbf5100/public",
  },
  {
    id: "silver",
    label: "Silver",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/ea0f67ed-a0b9-4d25-a868-31773a471e00/public",
  },
];

export const GIRL_ANIME_HAIR_LENGTH = [
  {
    id: "short hair",
    label: "Short",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/b1bb8cf5-dbee-45b7-2035-9c2899966200/public",
  },
  {
    id: "medium hair",
    label: "Medium",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c1d1304a-3ddf-4a42-6997-529ca674c100/public",
  },
  {
    id: "long hair",
    label: "Long",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/74fe364c-fbfe-4486-8eba-cb7bc6c6ec00/public",
  },
];

export const GIRL_ANIME_HAIRSTYLES = [
  {
    id: "straight",
    label: "Straight",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/c07f7a00-e2e4-4d06-fe71-6d7142f69600/public",
  },
  {
    id: "wavy",
    label: "Wavy",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/44b0d66c-bb37-47d0-0184-a99acae27600/public",
  },
  {
    id: "twintails",
    label: "Twintails",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/133f8362-d537-4057-40ba-ad8ea1d36900/public",
  },
  {
    id: "bangs",
    label: "Bangs",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/09a17a84-236a-4d38-4619-756a8ac22800/public",
  },
  {
    id: "bobcut",
    label: "Bobcut",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/992f6690-3908-4922-a013-60d133a59700/public",
  },
  {
    id: "ponytail",
    label: "Ponytail",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/667c6f61-dc98-4693-9aaa-e4e34fd21400/public",
  },
];

export const GIRL_ANIME_BODY_TYPE = [
  {
    id: "petite",
    label: "Petite",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/07e8d35a-34f1-44f1-5f81-f8ed03352600/public",
  },
  {
    id: "athletic",
    label: "Athletic",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/d4eb640a-0933-4385-8861-34bef43a3400/public",
  },
  {
    id: "hourglass figure",
    label: "Hourglass",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/944cbc5e-6417-4515-56a2-ff39e430eb00/public",
  },
  {
    id: "busty",
    label: "Busty",
    image:
      "https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/07bb94f9-43d6-4491-bff2-bf447e552a00/public",
  },
];

export const GIRL_ANIME_SUGGESTED_NAMES = [
  "Aiko",
  "Yui",
  "Hana",
  "Miyu",
  "Mei",
];

// ======== KEITARO ========\

/**
 * Keitaro environment configuration
 * Centralizing configuration variables in one place for easier management
 */

// Keitaro API and Tracking URLs
// Note: KEITARO_CAMPAIGN_URL is now accessed via ENV.KEITARO_CAMPAIGN_URL
export const KEITARO_API_TOKEN = "zg6pl2mfkhrndv4fdb97yb6bwlnrcck";

// S2S Postback configuration
export const KEITARO_PERSONAL_HASH = "cd110cf";
export const KEITARO_AID = "1";

// Other configurations
export const KEITARO_DEFAULT_PARAMS = {
  cost: "0.1",
  currency: "USD",
  creative_id: "banner_test",
  ad_campaign_id: "campaign_test",
  source: "zone_test",
  cohort: "cohort_a",
};

// Important URLs
export const KEITARO_ADMIN_URL = "http://155.138.200.99/admin";
export const KEITARO_S2S_POSTBACK_BASE_URL = `http://155.138.200.99/${KEITARO_PERSONAL_HASH}/postback`;
